import { Injectable } from "@angular/core"
import { CanActivate, Router } from '@angular/router';
import { AuthService } from "./auth.service";

@Injectable()

export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.loggedIn()) {
      // this.router.navigate(['www.google.com']);
      return true;
    } else {
      localStorage.clear();
      this.router.navigate(['/']);
      return false;
    }
  }
}
